import styled from "styled-components";

export const BoxStyled = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100px;
  background-color: white;
  margin-top: 20px;
  box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.06);
  border-radius: 8px;
  padding: 10px;
  min-height:${(prop) => (prop.minHeight ? prop.minHeight + "px" : "400px")};;
  position: relative;
`;

export const Card = styled.div`
  margin: 10px 10px;
  width: 100%;
  height: 100%;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
  padding: 1.2rem 1.7rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export const ResponsiveDivChart = styled.div`
  width: 100%;
  overflow-x: auto;
  direction: ltr;

`;
